<template>
  <pl-dialog
    size="md"
    :title="'Edit Follow-Up Questions'"
    class="text-gray-700 text-base"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <body class="mx-7 flex flex-col overflow-x-hidden h-full my-5">
      <div
        class="flex justify-between items-center space-x-2"
        :class="[{ 'pb-3': questions.length > 0 }]"
      >
        <input
          placeholder="Enter a Question"
          class="bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200"
          v-model="question_to_add"
          @keyup.enter="handleAddQuestion"
        />
        <button
          @click="handleAddQuestion"
          class="bg-blueGray-700 text-white py-2 px-4 rounded disabled:opacity-50"
          :disabled="loading"
        >
          Add
        </button>
      </div>
      <Draggable
        v-model="questions"
        @start="drag_content_resource = true"
        @end="drag_content_resource = false"
        class="h-full flex-grow overflow-y-auto"
      >
        <div v-for="(question, index) in questions" :key="index">
          <FollowUpQuestion
            :question="question"
            @handleDeleteQuestion="handleDeleteQuestion"
            @handleSaveInformation="handleSaveInformation"
            class="mb-3"
          />
        </div>
      </Draggable>
    </body>
    <footer class="mx-7 mb-5">
      <div class="flex justify-between w-full text-sm">
        <button
          class="px-4 py-2 mr-2 bg-white border border-solid border-gray-200 hover:shadow-sm rounded cursor-pointer text-gray-600"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          :disabled="loading"
          @click="saveFollowUpQuestions"
          class="sample px-5 py-2 bg-primary rounded cursor-pointer text-white font-medium disabled:opacity-50"
        >
          Save Changes
        </button>
      </div>
    </footer>
  </pl-dialog>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import FollowUpQuestion from './followUpQuestion.vue';
  export default {
    data() {
      return {
        loading: false,
        drag_content_resource: false,
        questions: [],
        is_editing_question: false,
        question_to_add: '',
      };
    },
    components: {
      Draggable: () => import('vuedraggable'),
      FollowUpQuestion,
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
        'getProfile',
        'hasTeacherPermissionsInCourse',
      ]),
      genieRecap() {
        return this.getCurrentRT.genie_recap;
      },
    },
    methods: {
      handleAddQuestion() {
        if (this.question_to_add === '') {
          const toast = {
            type: 'Error',
            message: 'Invalid Question or Empty Question !',
            time: 5000,
          };
          return EventBus.$emit('createToast', toast);
        }
        this.questions.push({
          id: this.questions.length,
          question: this.question_to_add,
        });
        this.question_to_add = '';
      },
      handleDeleteQuestion(q) {
        const index = this.questions.findIndex(
          (question) => question.id === q.id
        );
        if (index !== -1) {
          this.questions.splice(index, 1);
        }
      },
      handleSaveInformation(q) {
        this.questions.forEach((question) => {
          if (question.id === q.id) {
            question = q;
          }
        });
      },
      saveFollowUpQuestions() {
        this.loading = true;
        const array = [];
        this.questions.forEach((q, index) => {
          array.push({ id: index + 1, question: q.question });
        });
        const payload = {
          roundtable_id: this.getCurrentRT.id,
          questions: array,
        };
        this.$store
          .dispatch('updateGenieRecap', { id: this.genieRecap.id, payload })
          .then(() => {
            const toast = {
              type: 'Success',
              message: 'Follow-Up Questions successfully updated.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .catch((err) => {
            console.error(err);
            const toast = {
              type: 'Error',
              message:
                'Sorry! Something wrong happenned on updating follow-up questions! Try again!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .finally(() => (this.loading = false));
        this.$emit('close');
      },
    },
    mounted() {
      this.questions = JSON.parse(
        JSON.stringify(this.getCurrentRT.genie_recap.questions)
      );
    },
  };
</script>



// WEBPACK FOOTER //
// editFollowUpQuestions.vue?2a70362e